import { IAxiosResponse, IPaginator } from '../store/ducks/root.types'
import axiosInstance from './axios'
import { Alert } from '../store/application/models/alert/alert'
import moment from 'moment'

class AlertService {

  constructor(private apiVersion: string = 'v1') {
  }

  /**
   * 
   * @param startDate 
   * @param endDate 
   * @param paginator 
   * @returns 
   */
  public async getAll(startDate: string, endDate: string, paginator?: IPaginator): Promise<IAxiosResponse<Alert[]>> {
    const params: URLSearchParams = this.buildParams(startDate, endDate, paginator)
    return axiosInstance
      .get(`${this.apiVersion}/alerts`, { params })
      .then((response) => {
        return {
          data: response.data.map((data: any) => new Alert().fromJSON(data)),
          headers: response.headers
        }
      })
  }

  /**
   * 
   * @param alertId 
   * @returns 
   */
  public async getById(alertId: string): Promise<IAxiosResponse<Alert>> {
    return axiosInstance
      .get(`${this.apiVersion}/alerts/${alertId}`)
      .then((response) => {
        return {
          data: new Alert().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

  /**
   *      
   */
  public async updadeAlert(newAlert: Alert): Promise<IAxiosResponse<Alert>> {
    return axiosInstance
      .patch(`${this.apiVersion}/alerts/${newAlert.id}`,
        { ...newAlert.toJSON(), id: undefined, followup_id: undefined, patient_id: undefined })
      .then((response) => {
        return {
          data: new Alert().fromJSON(response.data),
          headers: response.headers
        }
      })
  }


  public buildParams(startDate: string, endDate: string, paginator?: IPaginator): URLSearchParams {
    const params = new URLSearchParams()
    if (paginator) {
      if (paginator.page) {
        params.append('page', String(paginator.page + 1))
      }
      if (paginator.rows) {
        params.append('limit', String(paginator.rows))
      }
    }
    if (startDate && endDate) {

      const startDateFomart = moment(startDate).subtract(1, 'days').toISOString().split("T")[0]
      const endDateFormat = moment(endDate).toISOString().split("T")[0]
      params.append('date', `gte:${startDateFomart}`)
      params.append('date', `lte:${endDateFormat}`)
      params.append("sort", `status`)
      params.append("sort", `date`)


    }
    return params
  }

}
const alertService = new AlertService()

export default alertService